import settingsService from "@/services/settingsService";

const state = () => ({
  all: [],
  single: null,
});

const actions = {
  async find({ commit, dispatch }) {
    try {
      const res = await settingsService.find();
      commit("setSingleSetting", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Einstellungen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      const res = await settingsService.update(formData);
      dispatch(
        "common/showSuccess",
        'Einstellungen wurden erfolgreich aktualisiert.',
        { root: true }
      );
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Einstellungen konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
};

const mutations = {
  setSingleSetting(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
